<template>
  <div>
    <span v-show="false">{{title}}</span>
    <person-report-tabs :buyer-or-seller="$route.params.buyerOrSeller"></person-report-tabs>
    <balance
        title=""
        :cols="(isXs)?mobileCols:datatableCols"
        url="reports/balance"
        :getAccountLedgerQuery="getAccountLedgerQuery"
        :getSubAccountLedgerQuery="getSubAccountLedgerQuery"
        :defaultFilters="defaultFilters"
        :is-person-report="true"
        ref="balance"
    />
  </div>
</template>

<script>
import datatableCols from "@/views/panel/balance/accounts/_datatableCols";
import Balance from "@/views/panel/balance/Balance";
import PersonReportTabs from "@/views/panel/personReport/PersonReportTab";

export default {
  name: "PersonReport",
  components: {PersonReportTabs, Balance},
  data() {
    return {
      datatableCols,
      defaultFilters: {
        level: 3,
        account_type: "buyer",
        cols_count: 4,
        balance_status: "with_transaction",
      },
      mobileCols: {
        cols: [
          {
            text: "نام حساب",
            value: "name",
          },
        ],
      }

    };
  },
  props: {
    detailed: {
      default: false
    }
  },
  updated() {
    this.defaultFilters.account_type = this.$route.params.buyerOrSeller
  },
  computed: {
    title() {
      return this.setDocumentTitle('گزارش حساب اشخاص')
    }
  },
  methods: {
    getAccountLedgerQuery(item) {
      return {
        "ledger.account": item.id,
        "ledger.level": `level${item.level}`,
      };
    },
    getSubAccountLedgerQuery(item, subAccount) {
      return {
        "ledger.account": item.id,
        "ledger.floatAccount": subAccount.level == "floatAccounts" ? subAccount.id : null,
        "ledger.level": `level${item.level}`,
      };
    },
  },
};
</script>
